import type { WorkerManager } from '../../../../worker';
import type { ChamferFeatureDefinitionModel } from '../../../definition/chamfer/ChamferFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import { FeaturePreviewExecution, type FeaturePreviewPresentationOptions } from '../FeaturePreviewExecution';

/**
 * 倒角特征预览执行器。
 */
export class ChamferPreviewExecution extends FeaturePreviewExecution<ChamferFeatureDefinitionModel> {
    /** Worker 管理器。 */
    private readonly workerManager: WorkerManager;

    /**
     * @param workerManager Worker 管理器。
     */
    public constructor(workerManager: WorkerManager) {
        super();
        this.workerManager = workerManager;
    }

    /**
     * @inheritdoc
     */
    public async executeCreatePreview(
        definition: ChamferFeatureDefinitionModel,
        options: FeaturePreviewPresentationOptions = {},
    ): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateChamferPreview(definition.getCommandParams(), {
            preferredItemRef: options.preferredItemRef ?? null,
        });
    }

    /**
     * @inheritdoc
     */
    public async executeEditPreview(
        session: FeatureEditSession<ChamferFeatureDefinitionModel>,
        definition: ChamferFeatureDefinitionModel,
        options: FeaturePreviewPresentationOptions = {},
    ): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateChamferPreviewInSandbox({
            commands: session.getPreviewCommands(),
            params: definition.getCommandParams(),
            preferredItemRef: options.preferredItemRef ?? null,
        });
    }
}
